import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { SubActions } from 'Redux/thunks/subscriptions.thunks';
import { canEditVPN } from 'Redux/selectors';
import { SettingsSubscriptionDnsView } from './SettingsSubscriptionDns.view';

import type { RootState } from 'Types/state.types';
import type { DnsForwardingConfig } from 'Types/subscription.types';

const EMPTY_DNS_CONFIG: DnsForwardingConfig = {};

export const SettingsSubscriptionDns: React.FC = () => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const subId = useSelector((state: RootState) => state.subscription.id);
  const subData = useSelector((state: RootState) =>
    state.subscriptions.find((s: { id: string }) => s.id === state.subscription.id)
  );
  const canEdit = useSelector((state: RootState) => canEditVPN(state));

  const dnsConfig: DnsForwardingConfig = subData?.dns || EMPTY_DNS_CONFIG;

  const handleSave = (config: DnsForwardingConfig) => {
    setIsSubmitting(true);
    return (dispatch as any)(SubActions.updateDnsForwarding(subId, config)).finally(() =>
      setIsSubmitting(false)
    );
  };

  if (!canEdit) {
    return null;
  }

  return (
    <SettingsSubscriptionDnsView
      dnsConfig={dnsConfig}
      onSave={handleSave}
      isSubmitting={isSubmitting}
    />
  );
};
